export default {
  getProposal(state) {
    return state.proposal ? state.proposal : {};
  },
};
